// useVoiceChat - 后台薄包装层
//
// 🔁 2026-10-27：唤醒 / 流式 ASR / TTS 通用逻辑已迁入 @huyu/core（后台与 AI 前台共用）。
//   本文件只注册后台运行时（Element Plus 提示 + huyuAI speech 接口 + tts store）。
import { useVoiceChat as useCoreVoiceChat } from '@huyu/core/vue'
import { ensureAiRuntime } from './aiRuntime'

export function useVoiceChat(options = {}) {
  ensureAiRuntime()
  return useCoreVoiceChat(options)
}

export default useVoiceChat
